export const buildNestedObject = (data) => {
    const result = {};

    data.forEach(({ key, value }) => {
        const keys = key.split('.');
        let current = result;

        keys.forEach((part, index) => {
            const isLast = index === keys.length - 1;
            const isArrayIndex = !isNaN(Number(part)); // check if number

            if (isLast) {
                // Set the value
                if (isArrayIndex) {
                    if (!Array.isArray(current)) current = []; // make sure current is array
                    current[Number(part)] = value;
                } else {
                    current[part] = value;
                }
            } else {
                // Prepare next level
                const nextPart = keys[index + 1];
                const nextIsArray = !isNaN(Number(nextPart));

                if (isArrayIndex) {
                    // Current should be array
                    if (!Array.isArray(current)) current = [];
                    if (!current[Number(part)]) current[Number(part)] = nextIsArray ? [] : {};
                    current = current[Number(part)];
                } else {
                    // Current should be object
                    if (!current[part]) current[part] = nextIsArray ? [] : {};
                    current = current[part];
                }
            }
        });
    });

    return result;
}